<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import request, {get} from "./utils/request";

export default {
  name: 'App',
  mounted() {
    this.getUserInfo()
  },
  methods:{
    getUserInfo(){
      let user = localStorage.getItem('user');
      if(!user){
        request({
          url: '/website/auth/userInfo'
        }).then(res=>{
            localStorage.setItem('user',JSON.stringify(res.data))
        })
      }

    }
  }
}
</script>

<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue